AFRAME.registerComponent('add-to-watchlist-vr-popup', {
    init: function() {
        this.el.setAttribute('visible', false);
        this.el.setAttribute('scale', '0 0 0');

        if (window.PopupManager) {
            window.PopupManager.register('add-to-watchlist-vr-popup', this.el);
        }
        
        this.ticker = null;
        this.companyName = null;
        this.selectedWatchlistIndex = 0;
        this.watchlists = [];

        this.el.sceneEl.addEventListener('theme-changed', () => {
            if (this.el.getAttribute('visible')) {
                this.render();
            }
        });
    },

    setup: function(ticker, companyName) {
        this.ticker = ticker;
        this.companyName = companyName;
        this.fetchWatchlists();
    },

    fetchWatchlists: function() {
        if (window.WatchlistAPIManager) {
            window.WatchlistAPIManager.instance.getWatchlists().then(data => {
                this.watchlists = data.watchlists || [];
                this.selectedWatchlistIndex = 0;
                this.render();
            });
        }
    },

    open: function() {
        this.render();
    },

    close: function() {
        const qtyInput = document.querySelector('#vr-atw-qty-input');
        if (qtyInput) {
            qtyInput.value = '';
            const qtyText = this.el.querySelector('#vr-atw-qty-text');
            if (qtyText) qtyText.setAttribute('value', '');
        }
        const priceInput = document.querySelector('#vr-atw-price-input');
        if (priceInput) {
            priceInput.value = '';
            const priceText = this.el.querySelector('#vr-atw-price-text');
            if (priceText) priceText.setAttribute('value', '');
        }
    },

    nextWatchlist: function() {
        if (this.watchlists.length === 0) return;

        const manager = window.WatchlistApp && window.WatchlistApp.Manager;
        const isPremium = manager && manager.isPremiumUser && manager.isPremiumUser();

        if (!isPremium) {
            if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showPremiumLockPopup) {
                window.WatchlistApp.Popup.showPremiumLockPopup();
            }
            return;
        }

        this.selectedWatchlistIndex = (this.selectedWatchlistIndex + 1) % this.watchlists.length;
        this.render();
    },

    render: function() {
        this.el.innerHTML = '';
        const isLight = (typeof getCacheItem === 'function' && getCacheItem('mainSettings')?.themeMode === 'Light');
        const bgColor = isLight ? '#F5F5F5' : '#111';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 0.8);
        bg.setAttribute('height', 0.7);
        bg.setAttribute('position', '-0.4 -0.35 0');
        bg.setAttribute('color', bgColor);
        bg.setAttribute('radius', 0.02);
        this.el.appendChild(bg);

        const title = document.createElement('a-troika-text');
        title.setAttribute('value', `Add ${this.ticker || 'Stock'} to`);
        title.setAttribute('font-size', 0.04);
        title.setAttribute('color', txtColor);
        title.setAttribute('position', '0 0.28 0.01');
        title.setAttribute('anchor', 'center');
        this.el.appendChild(title);

        const closeGroup = document.createElement('a-entity');
        closeGroup.setAttribute('position', '0.36 0.31 0.01');
        this.el.appendChild(closeGroup);

        const closeText = document.createElement('a-troika-text');
        closeText.setAttribute('value', '×');
        closeText.setAttribute('font-size', 0.06);
        closeText.setAttribute('color', txtColor);
        closeText.setAttribute('anchor', 'center');
        closeGroup.appendChild(closeText);

        const closeHitbox = document.createElement('a-plane');
        closeHitbox.setAttribute('width', 0.08);
        closeHitbox.setAttribute('height', 0.08);
        closeHitbox.setAttribute('opacity', 0);
        closeHitbox.setAttribute('data-raycastable', '');
        closeHitbox.addEventListener('click', () => window.WatchlistApp.Popup.closeManual('add-to-watchlist-vr-popup'));
        closeGroup.appendChild(closeHitbox);

        const content = document.createElement('a-entity');
        content.setAttribute('position', '0 0.05 0.01');
        this.el.appendChild(content);

        const currentWatchlist = this.watchlists[this.selectedWatchlistIndex];
        const watchlistName = currentWatchlist ? currentWatchlist.name : 'Loading...';

        const wlSelectorGroup = document.createElement('a-entity');
        wlSelectorGroup.setAttribute('position', '0 0.12 0');
        content.appendChild(wlSelectorGroup);

        const wlBox = document.createElement('a-rounded-box');
        wlBox.setAttribute('width', 0.6);
        wlBox.setAttribute('height', 0.08);
        wlBox.setAttribute('depth', 0.01);
        wlBox.setAttribute('color', '#3636E3');
        wlBox.setAttribute('radius', 0.01);
        wlBox.setAttribute('data-raycastable', '');
        wlBox.addEventListener('click', () => this.nextWatchlist());
        wlSelectorGroup.appendChild(wlBox);

        const wlText = document.createElement('a-troika-text');
        wlText.setAttribute('value', watchlistName);
        wlText.setAttribute('font-size', 0.035);
        wlText.setAttribute('color', '#FFF');
        wlText.setAttribute('anchor', 'center');
        wlText.setAttribute('position', '0 0 0.01');
        wlSelectorGroup.appendChild(wlText);

        const wlHint = document.createElement('a-troika-text');
        wlHint.setAttribute('value', '(Click to change watchlist)');
        wlHint.setAttribute('font-size', 0.02);
        wlHint.setAttribute('color', '#888');
        wlHint.setAttribute('anchor', 'center');
        wlHint.setAttribute('position', '0 -0.06 0');
        wlSelectorGroup.appendChild(wlHint);

        const inputsRow = document.createElement('a-entity');
        inputsRow.setAttribute('position', '0 -0.05 0');
        content.appendChild(inputsRow);

        const qtyGroup = document.createElement('a-entity');
        qtyGroup.setAttribute('position', '-0.18 0 0');
        inputsRow.appendChild(qtyGroup);

        const qtyLabel = document.createElement('a-troika-text');
        qtyLabel.setAttribute('value', '# of Shares');
        qtyLabel.setAttribute('font-size', 0.025);
        qtyLabel.setAttribute('color', '#888');
        qtyLabel.setAttribute('position', '0 0.06 0');
        qtyLabel.setAttribute('anchor', 'center');
        qtyGroup.appendChild(qtyLabel);

        const qtyFocusBorder = document.createElement('a-rounded-box');
        qtyFocusBorder.setAttribute('width', 0.36);
        qtyFocusBorder.setAttribute('height', 0.10);
        qtyFocusBorder.setAttribute('depth', 0.004);
        qtyFocusBorder.setAttribute('color', '#3636E3');
        qtyFocusBorder.setAttribute('position', '0 -0.04 -0.001');
        qtyFocusBorder.setAttribute('radius', 0.012);
        qtyFocusBorder.setAttribute('visible', false);
        qtyGroup.appendChild(qtyFocusBorder);
        this._qtyFocusBorder = qtyFocusBorder;

        const qtyBox = document.createElement('a-rounded-box');
        qtyBox.setAttribute('width', 0.34);
        qtyBox.setAttribute('height', 0.08);
        qtyBox.setAttribute('depth', 0.005);
        qtyBox.setAttribute('color', isLight ? '#DDD' : '#333');
        qtyBox.setAttribute('position', '0 -0.04 0');
        qtyBox.setAttribute('radius', 0.01);
        qtyBox.setAttribute('data-raycastable', '');
        qtyGroup.appendChild(qtyBox);

        const qtyText = document.createElement('a-troika-text');
        qtyText.setAttribute('id', 'vr-atw-qty-text');
        qtyText.setAttribute('value', '');
        qtyText.setAttribute('font-size', 0.035);
        qtyText.setAttribute('color', txtColor);
        qtyText.setAttribute('position', '0 -0.04 0.01');
        qtyText.setAttribute('anchor', 'center');
        qtyGroup.appendChild(qtyText);

        const qtyHitbox = document.createElement('a-entity');
        qtyHitbox.setAttribute('position', '0 -0.04 0.012');
        qtyHitbox.setAttribute('geometry', 'primitive: plane; width: 0.34; height: 0.08');
        qtyHitbox.setAttribute('html', 'html:#vr-atw-qty-input; cursor:#cursor');
        qtyHitbox.setAttribute('material', 'shader: flat; opacity: 0; transparent: true');
        qtyHitbox.setAttribute('data-raycastable', '');
        qtyGroup.appendChild(qtyHitbox);

        const priceGroup = document.createElement('a-entity');
        priceGroup.setAttribute('position', '0.18 0 0');
        inputsRow.appendChild(priceGroup);

        const priceLabel = document.createElement('a-troika-text');
        priceLabel.setAttribute('value', 'Cost Basis');
        priceLabel.setAttribute('font-size', 0.025);
        priceLabel.setAttribute('color', '#888');
        priceLabel.setAttribute('position', '0 0.06 0');
        priceLabel.setAttribute('anchor', 'center');
        priceGroup.appendChild(priceLabel);

        const priceFocusBorder = document.createElement('a-rounded-box');
        priceFocusBorder.setAttribute('width', 0.36);
        priceFocusBorder.setAttribute('height', 0.10);
        priceFocusBorder.setAttribute('depth', 0.004);
        priceFocusBorder.setAttribute('color', '#3636E3');
        priceFocusBorder.setAttribute('position', '0 -0.04 -0.001');
        priceFocusBorder.setAttribute('radius', 0.012);
        priceFocusBorder.setAttribute('visible', false);
        priceGroup.appendChild(priceFocusBorder);
        this._priceFocusBorder = priceFocusBorder;

        const priceBox = document.createElement('a-rounded-box');
        priceBox.setAttribute('width', 0.34);
        priceBox.setAttribute('height', 0.08);
        priceBox.setAttribute('depth', 0.005);
        priceBox.setAttribute('color', isLight ? '#DDD' : '#333');
        priceBox.setAttribute('position', '0 -0.04 0');
        priceBox.setAttribute('radius', 0.01);
        priceBox.setAttribute('data-raycastable', '');
        priceGroup.appendChild(priceBox);

        const priceText = document.createElement('a-troika-text');
        priceText.setAttribute('id', 'vr-atw-price-text');
        priceText.setAttribute('value', '');
        priceText.setAttribute('font-size', 0.035);
        priceText.setAttribute('color', txtColor);
        priceText.setAttribute('position', '0 -0.04 0.01');
        priceText.setAttribute('anchor', 'center');
        priceGroup.appendChild(priceText);

        const priceHitbox = document.createElement('a-entity');
        priceHitbox.setAttribute('position', '0 -0.04 0.012');
        priceHitbox.setAttribute('geometry', 'primitive: plane; width: 0.34; height: 0.08');
        priceHitbox.setAttribute('html', 'html:#vr-atw-price-input; cursor:#cursor');
        priceHitbox.setAttribute('material', 'shader: flat; opacity: 0; transparent: true');
        priceHitbox.setAttribute('data-raycastable', '');
        priceGroup.appendChild(priceHitbox);

        const buttons = document.createElement('a-entity');
        buttons.setAttribute('position', '0 -0.25 0.02');
        content.appendChild(buttons);

        const cancelBtn = document.createElement('a-entity');
        cancelBtn.setAttribute('position', '-0.15 0 0');
        cancelBtn.setAttribute('ui-button', {
            label: 'Cancel',
            width: 0.18,
            height: 0.07,
            colorScheme: 'primary',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.04
        });
        cancelBtn.addEventListener('click', () => window.WatchlistApp.Popup.closeManual('add-to-watchlist-vr-popup'));
        buttons.appendChild(cancelBtn);

        const addBtn = document.createElement('a-entity');
        addBtn.setAttribute('position', '0.15 0 0');
        addBtn.setAttribute('ui-button', {
            label: 'Add',
            width: 0.18,
            height: 0.07,
            colorScheme: 'accent',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.04
        });
        addBtn.addEventListener('click', () => this.handleConfirm());
        buttons.appendChild(addBtn);

        this.setupInputs();
    },

    setupInputs: function() {
        const qtyInput = document.querySelector('#vr-atw-qty-input');
        const priceInput = document.querySelector('#vr-atw-price-input');
        const qtyText = this.el.querySelector('#vr-atw-qty-text');
        const priceText = this.el.querySelector('#vr-atw-price-text');

        if (qtyInput) {
            qtyInput.oninput = (e) => {
                if(qtyText) {
                    const displayVal = window.WatchlistApp.Utils ? window.WatchlistApp.Utils.truncateInputDisplay(e.target.value) : e.target.value;
                    qtyText.setAttribute('value', displayVal);
                }
            };
            qtyInput.onfocus = () => {
                if (this._qtyFocusBorder) this._qtyFocusBorder.setAttribute('visible', true);
                if (this._priceFocusBorder) this._priceFocusBorder.setAttribute('visible', false);
            };
            qtyInput.onblur = () => {
                if (this._qtyFocusBorder) this._qtyFocusBorder.setAttribute('visible', false);
            };
        }
        if (priceInput) {
             priceInput.oninput = (e) => {
                if(priceText) {
                    const displayVal = window.WatchlistApp.Utils ? window.WatchlistApp.Utils.truncateInputDisplay(e.target.value) : e.target.value;
                    priceText.setAttribute('value', displayVal);
                }
            };
            priceInput.onfocus = () => {
                if (this._priceFocusBorder) this._priceFocusBorder.setAttribute('visible', true);
                if (this._qtyFocusBorder) this._qtyFocusBorder.setAttribute('visible', false);
            };
            priceInput.onblur = () => {
                if (this._priceFocusBorder) this._priceFocusBorder.setAttribute('visible', false);
            };
        }
    },

    handleConfirm: function() {
        const currentWatchlist = this.watchlists[this.selectedWatchlistIndex];
        if (!currentWatchlist || !this.ticker) return;

        const qtyInput = document.querySelector('#vr-atw-qty-input');
        const priceInput = document.querySelector('#vr-atw-price-input');
        const qty = parseFloat(qtyInput?.value || 0) || 0;
        const price = parseFloat(priceInput?.value || 0) || 0;

        if (window.WatchlistAPIManager) {
            window.WatchlistApp.Popup.closeManual('add-to-watchlist-vr-popup');
            
            const Manager = window.WatchlistApp.Manager;
            const State = window.WatchlistApp.State;

            window.WatchlistAPIManager.instance.addTickerToWatchlist(currentWatchlist.id, this.ticker, qty, price)
                .then(async res => {
                    if (res && res.success) {
                         if (window.WatchlistApp.Popup.showNotificationPopup) {
                            window.WatchlistApp.Popup.showNotificationPopup("Success", `Added ${this.ticker} to ${currentWatchlist.name}`);
                         }
                         
                         if (Manager) {
                             await Manager.updateWatchlistState();
                             if (State && State.currentWatchlistId === currentWatchlist.id) {
                                 let shouldRender = false;
                                 const cube = document.getElementById('stock-3d-cube');
                                 if (cube) {
                                     const attr = cube.getAttribute('stock-cube-visualizer');
                                     if (attr && attr.dataSource === 'watchlist-reports') {
                                         shouldRender = true;
                                     }
                                 }
                                 await Manager.loadWatchlistData(State.currentUserId, State.currentWatchlistId, [], null, shouldRender);
                             }
                         }
                    } else {
                        console.error("Failed to add to watchlist", res);
                         if (window.WatchlistApp.Popup.showNotificationPopup) {
                            window.WatchlistApp.Popup.showNotificationPopup("Error", "Failed to add to watchlist");
                         }
                    }
                })
                .catch(err => {
                    console.error(err);
                    if (window.WatchlistApp.Popup.showNotificationPopup) {
                        window.WatchlistApp.Popup.showNotificationPopup("Error", "An error occurred");
                    }
                });
        }
    }
});
